import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ResultTable from "../../../components/table/ResultTable";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import CheckCSName from "../CheckCSName";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";

export default function SV5({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

function Description({row, settings, globalVariables}) {
    switch (row.error_id) {
        case MessageCodes.Internal.SV5_SV05.error_id: {
            return (
                <ResultText>
                    The culvert length is not consistent with the survey data at the following {row?.data?.length} culverts.
                    <ResultTable maxWidth={HecRasHelper.getWidth(60)}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={1} style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>Culvert</ResultHeaderCell>
                                <ResultHeaderCell colSpan={1} style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell colSpan={1} style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {

                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>
                                                Culvert {r?.culvert_num} RS <CheckCSName csName={r?.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>{r?.survey_len?.toFixed(2)}</ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                {ResultCellHighlight(r?.survey_len?.toFixed(2), r?.culv_len?.toFixed(2))}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </ResultText>
            )
        }
    }
}